module.exports = __webpack_public_path__ + "static/media/image-upload.f3ac55a2.svg";